__turbopack_context__.v({
  "actions": "PlasmicForgotPasswordForm-module__B6QQOq__actions",
  "backToLoginBtn": "PlasmicForgotPasswordForm-module__B6QQOq__backToLoginBtn",
  "bottom": "PlasmicForgotPasswordForm-module__B6QQOq__bottom",
  "desc": "PlasmicForgotPasswordForm-module__B6QQOq__desc",
  "email": "PlasmicForgotPasswordForm-module__B6QQOq__email",
  "emailInput": "PlasmicForgotPasswordForm-module__B6QQOq__emailInput",
  "emailWrapper": "PlasmicForgotPasswordForm-module__B6QQOq__emailWrapper",
  "forgotPasswordForm": "PlasmicForgotPasswordForm-module__B6QQOq__forgotPasswordForm",
  "form": "PlasmicForgotPasswordForm-module__B6QQOq__form",
  "header": "PlasmicForgotPasswordForm-module__B6QQOq__header",
  "heading": "PlasmicForgotPasswordForm-module__B6QQOq__heading",
  "img__aeFzs": "PlasmicForgotPasswordForm-module__B6QQOq__img__aeFzs",
  "img__e7Nxd": "PlasmicForgotPasswordForm-module__B6QQOq__img__e7Nxd",
  "label": "PlasmicForgotPasswordForm-module__B6QQOq__label",
  "line": "PlasmicForgotPasswordForm-module__B6QQOq__line",
  "link": "PlasmicForgotPasswordForm-module__B6QQOq__link",
  "link__rfVAo": "PlasmicForgotPasswordForm-module__B6QQOq__link__rfVAo",
  "loginFormResources": "PlasmicForgotPasswordForm-module__B6QQOq__loginFormResources",
  "loginFormSecurity": "PlasmicForgotPasswordForm-module__B6QQOq__loginFormSecurity",
  "logo": "PlasmicForgotPasswordForm-module__B6QQOq__logo",
  "resetPassword": "PlasmicForgotPasswordForm-module__B6QQOq__resetPassword",
  "resetPasswordBtn": "PlasmicForgotPasswordForm-module__B6QQOq__resetPasswordBtn",
  "root": "PlasmicForgotPasswordForm-module__B6QQOq__root",
  "section": "PlasmicForgotPasswordForm-module__B6QQOq__section",
  "serviceMessage": "PlasmicForgotPasswordForm-module__B6QQOq__serviceMessage",
  "spinnerIcon": "PlasmicForgotPasswordForm-module__B6QQOq__spinnerIcon",
  "svg___3L40Z": "PlasmicForgotPasswordForm-module__B6QQOq__svg___3L40Z",
  "svg___8DCc0": "PlasmicForgotPasswordForm-module__B6QQOq__svg___8DCc0",
  "svg___90Pl": "PlasmicForgotPasswordForm-module__B6QQOq__svg___90Pl",
  "svg__obP09": "PlasmicForgotPasswordForm-module__B6QQOq__svg__obP09",
  "svg__so0Yn": "PlasmicForgotPasswordForm-module__B6QQOq__svg__so0Yn",
  "text___38MSa": "PlasmicForgotPasswordForm-module__B6QQOq__text___38MSa",
  "text__ydY34": "PlasmicForgotPasswordForm-module__B6QQOq__text__ydY34",
  "title": "PlasmicForgotPasswordForm-module__B6QQOq__title",
  "wrapper": "PlasmicForgotPasswordForm-module__B6QQOq__wrapper",
});
